<tui-root>
  <app-main-layout></app-main-layout>
</tui-root>
